/**
* Swiping Sections JS
* -----------------------------------------------------------------------------
*
* All the JS for the Swiping Sections component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'swiping-sections',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.swiping-sections' ).each( function( key, val ) {
        // account for pinSpacing: false
        $( this ).height( ( ( window.innerWidth * $( this ).find( '.single-section' ).length ) + ( window.innerHeight * -0.75 ) ) + window.innerHeight );

        // swipe the sections and move the content/image/colorblock a bit
        $( this ).find( '.single-section' ).each( function( sectionKey, sectionVal ) {
          const sectionNext = $( this ).next()[0];
          const sectionColorBox = $( this ).find( '.color-box' )[0];
          const sectionContent = $( this ).find( '.wysiwyg' )[0];
          const swipeStart = ( window.innerWidth * sectionKey );
          let sectionImage = $( this ).find( '.image-wrapper' )[0];
          if ( $( this ).find( 'video' ).length ) {
            sectionImage = $( this ).find( 'video' )[0];
            sectionImage.currentTime = 0;
          }

          let moveStart = 0;
          let ending = window.innerHeight * 1.5;

          if ( window.innerWidth < 1025 ) {
            ending = window.innerHeight * 0.4;
          }

          // ======== START SWIPE STUFF ========

          // swipe the sections
          const swiper = gsap.timeline( {
            scrollTrigger: {
              trigger: val,
              start: swipeStart + ' ' + window.navHeight,
              end: '+=' + ending,
              scrub: 0,
              // markers: true,
              refreshPriority: -1,
            },
          } );

          // reveal the next one as the current one is hiding
          if ( sectionNext ) {
            swiper.to( sectionNext, {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', ease: 'linear'}, 0 );
          }

          // hide the current one
          if ( sectionVal !== $( val ).find( '.single-section:last-child' )[0] ) {
            swiper.to( sectionVal, {clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)', ease: 'linear'}, 0 );
          }

          // ======== END SWIPE STUFF ========
          // ======== START MOVE STUFF ========

          // if a middle panel, make it "pin" twice as long, to give the same effect
          if ( sectionKey !== 0 && sectionKey + 1 !== $( val ).find( '.single-section' ).length ) {
            moveStart = ( window.innerHeight * sectionKey ) - window.innerHeight;
          } else {
            moveStart = ( window.innerHeight * sectionKey );
          }

          // move the content/image/colorblock a bit
          const mover = gsap.timeline( {
            scrollTrigger: {
              trigger: val,
              start: ( moveStart ) + ' ' + window.navHeight,
              end: '+=' + ( window.innerHeight * 5 ),
              scrub: 0,
              // markers: true,
              refreshPriority: -1,
              onEnter: ( x, y, z ) => {
                if ( $( this ).find( 'video' ).length ) {
                  $( this ).find( 'video' )[0].play();
                }
              },
            },
          } );
          mover.to( sectionContent, {x: '-13%', ease: 'linear'}, 0 );
          mover.to( sectionImage, {x: '-18%', ease: 'linear'}, 0 );

          if ( window.innerWidth > 1024 ) {
            mover.to( sectionColorBox, {x: '-25vw', ease: 'linear'}, 0 );
          }

          // ======== END MOVE STUFF ========
          // ======== START VIDEO STUFF ========
          if ( $( this ).find( 'video' ).length ) {
            $( this ).find( 'video' )[0].playbackRate = 0.75;
          }
          // // play videos when the section is reached
          // if ( $( this ).find( 'video' ).length ) {
          //   const starter = window.innerHeight * sectionKey;
          //   let vidStart = starter * 0.75;
          //   if ( ( sectionKey + 1 ) % 2 == 0 ) {
          //     vidStart = starter * 0.75;
          //   } else if ( sectionKey == 0 ) {
          //     vidStart = window.innerHeight * -0.25;
          //   }
          //   const vidPlayer = gsap.timeline( {
          //     scrollTrigger: {
          //       trigger: val,
          //       start: vidStart + ' ' + window.navHeight,
          //       end: vidStart + ' ' + window.navHeight,
          //       scrub: 0,
          //       // markers: true,
          //       refreshPriority: -1,
          //       onEnter: ( x, y, z ) => {
          //         $( this ).find( 'video' )[0].playbackRate = 0.75;
          //         $( this ).find( 'video' )[0].play();
          //       },
          //     },
          //   } );
          // }

          // play videos when the section is reached
          if ( $( this ).find( 'video' ).length || $( this ).find( '.animating-svg-wrapper' ).length ) {
            const starter = window.innerHeight * sectionKey;
            let vidStart = starter * 0.75;
            if ( ( sectionKey + 1 ) % 2 == 0 ) {
              vidStart = starter * 0.75;
            } else if ( sectionKey == 0 ) {
              vidStart = window.innerHeight * -0.25;
            }
            const vidPlayer = gsap.timeline( {
              scrollTrigger: {
                trigger: val,
                start: vidStart + ' ' + window.navHeight,
                end: vidStart + ' ' + window.navHeight,
                scrub: 0,
                // markers: true,
                refreshPriority: -1,
                onEnter: ( x, y, z ) => {
                  if ( $( this ).find( 'video' ).length ) {
                    $( this ).find( 'video' )[0].playbackRate = 0.75;
                    $( this ).find( 'video' )[0].play();
                  }
                  if ( $( this ).find( '.animating-svg-wrapper' ).length ) {
                    $( this ).find( '.animating-svg' ).addClass( 'is-loaded' );
                  }
                },
              },
            } );
          }
        } );

        // ======== END VIDEO STUFF ========
        // ======== START PINNING ========

        // pin the section
        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: val,
            pin: $( this ).find( '.inner-area' )[0],
            start: 'top ' + window.navHeight,
            end: '=+' + ( ( window.innerWidth * $( this ).find( '.single-section' ).length ) + ( window.innerHeight * -0.75 ) ),
            scrub: 0,
            refreshPriority: -1,
            pinSpacing: false,
            onEnter: ( x, y, z ) => {
              $( val ).removeClass( 'force-clip' ); // gsap was having issues where it would jump and show the next section before it should have, and the force-clip class will take care of it
            },
            onLeaveBack: ( x, y, z ) => {
              $( val ).addClass( 'force-clip' );
            },
            // markers: true,
          },
        } );
        // ======== END PINNING ========
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'swiping-sections', COMPONENT );
} )( app );
